export default "__VITE_ASSET__DSo72uBr__";